module.exports = __webpack_public_path__ + "static/img/lose.ee21a372.png";